import { qltClient } from '../clients';
import type { QueryParams } from '../core/params';
import type { Id, IztContentNode } from '../types';

export interface IztContentTreeParams extends QueryParams {
  class: Id;
  grade?: Id;
  subject?: Id;
}

// Served by QLT, not by an IZTeach gateway - lms-api proxies the content tree.
export const IztContentRepository = {
  getTree: (params: IztContentTreeParams) =>
    qltClient.get('/izt-content/tree', { params }).then((res) => res.data as IztContentNode[]),
};

export default IztContentRepository;
